// FB 14847
import React, {
    useEffect, useState, useContext, useCallback
} from 'react';
import PropTypes from 'prop-types';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { useAuthentication } from 'gw-digital-auth-react';
import { UserService } from 'gw-capability-ri-policy';
import { TranslatorContext } from '@jutro/locale';
// import { _ } from 'core-js';
import _, { update } from 'lodash';
import styles from './RIFormsOrderComponent.module.scss';
import messages from './RIFormsOrderComponent.messages';
import metadata from './RIFormsOrderComponent.metadata.json5';

const getStateDropdown = () => {
    const stateSelect = [
        { code: 'AL', name: 'Alabama' },
        { code: 'AK', name: 'Alaska' },
        { code: 'AB', name: 'Alberta' },
        { code: 'AZ', name: 'Arizona' },
        { code: 'AR', name: 'Arkansas' },
        { code: 'BC', name: 'British Columbia' },
        { code: 'CA', name: 'California' },
        { code: 'CZ', name: 'Canal Zone' },
        { code: 'CO', name: 'Colorado' },
        { code: 'CT', name: 'Connecticut' },
        { code: 'DE', name: 'Delaware' },
        { code: 'DC', name: 'District of Columbia' },
        { code: 'FSM', name: 'Federated States of Micronesia' },
        { code: 'FL', name: 'Florida' },
        { code: 'GA', name: 'Georgia' },
        { code: 'GU', name: 'Guam' },
        { code: 'HI', name: 'Hawaii' },
        { code: 'ID', name: 'Idaho' },
        { code: 'IL', name: 'Illinois' },
        { code: 'IN', name: 'Indiana' },
        { code: 'IA', name: 'Iowa' },
        { code: 'KS', name: 'Kansas' },
        { code: 'KY', name: 'Kentucky' },
        { code: 'LA', name: 'Louisiana' },
        { code: 'ME', name: 'Maine' },
        { code: 'MB', name: 'Manitoba' },
        { code: 'MH', name: 'Marshall Islands' },
        { code: 'MD', name: 'Maryland' },
        { code: 'MA', name: 'Massachusetts' },
        { code: 'MI', name: 'Michigan' },
        { code: 'MN', name: 'Minnesota' },
        { code: 'MS', name: 'Mississippi' },
        { code: 'MO', name: 'Missouri' },
        { code: 'MT', name: 'Montana' },
        { code: 'NE', name: 'Nebraska' },
        { code: 'NV', name: 'Nevada' },
        { code: 'NB', name: 'New Brunswick' },
        { code: 'NH', name: 'New Hampshire' },
        { code: 'NJ', name: 'New Jersey' },
        { code: 'NM', name: 'New Mexico' },
        { code: 'NY', name: 'New York' },
        { code: 'NL', name: 'Newfoundland and Labrador' },
        { code: 'NC', name: 'North Carolina' },
        { code: 'ND', name: 'North Dakota' },
        { code: 'MP', name: 'Northern Mariana Islands' },
        { code: 'NT', name: 'Northwest Territories' },
        { code: 'NS', name: 'Nova Scotia' },
        { code: 'NU', name: 'Nunavut' },
        { code: 'OH', name: 'Ohio' },
        { code: 'OK', name: 'Oklahoma' },
        { code: 'ON', name: 'Ontario' },
        { code: 'OR', name: 'Oregon' },
        { code: 'PA', name: 'Pennsylvania' },
        { code: 'PE', name: 'Prince Edward Island' },
        { code: 'PR', name: 'Puerto Rico' },
        { code: 'QC', name: 'Quebec' },
        { code: 'RI', name: 'Rhode Island' },
        { code: 'SK', name: 'Saskatchewan' },
        { code: 'SC', name: 'South Carolina' },
        { code: 'SD', name: 'South Dakota' },
        { code: 'TN', name: 'Tennessee' },
        { code: 'TX', name: 'Texas' },
        { code: 'UT', name: 'Utah' },
        { code: 'VT', name: 'Vermont' },
        { code: 'VI', name: 'Virgin Islands' },
        { code: 'VA', name: 'Virginia' },
        { code: 'WA', name: 'Washington' },
        { code: 'WV', name: 'West Virginia' },
        { code: 'WI', name: 'Wisconsin' },
        { code: 'WY', name: 'Wyoming' },
        { code: 'YT', name: 'Yukon' }
    ];
    return stateSelect;
};

function RIFormsOrderComponent(props) {
    const translator = useContext(TranslatorContext);
    const { selectedItems, userInfo } = props;
    const { authHeader } = useAuthentication();

    const [userInfo2, setUserInfo2] = useState({});
    const [stateValues, setStateValues] = useState([]);
    const [selectedState, setSelectedState] = useState('');
    const [pageError, updatePageError] = useState();
    const [isLoading, setLoadingState] = useState(false);

    useEffect(() => {
        setUserInfo2(userInfo);
        setStateValues(getStateDropdown());
    }, []);

    useEffect(() => {
        setSelectedState(userInfo.mailingAddress.state);
    }, []);

    const clickNext = () => {
        props.capability[0](selectedItems);
    };
    const clickPrevious = () => {
        props.capability[1]();
    };

    const cancelOrder = () => {
        props.capability[2]();
    };

    const orderPlaced = () => {
        props.capability[3]();
    };

    const processingOrder = (isProcessing) => {
        props.capability[4](isProcessing);
    };

    const changeState = (value) => {
        setSelectedState(value);

        const newUserInfo = { ...userInfo2 };
        newUserInfo.mailingAddress.state = value;
        setUserInfo2(newUserInfo);
    };

    const readValue = useCallback(
        (id, path) => {
            return _.get(userInfo2, path);
        },
        [userInfo2]
    );

    const writeValue = useCallback(
        (value, path) => {
            if (path.includes('.')) {
                // for the sub object, need to update its propety first
                const mainPath = path.split('.')[0];
                const subPath = path.split('.')[1];
                const subObject = { ...userInfo2[mainPath], [subPath]: value };
                // then update the object as the main propety
                setUserInfo2({ ...userInfo2, [mainPath]: subObject });
            } else {
                setUserInfo2({ ...userInfo2, [path]: value });
            }
        },
        [userInfo2]
    );

    const validate = () => {
        // alert(JSON.stringify(userInfo2))
        if (_.isEmpty(userInfo2.name) ||
			_.isEmpty(userInfo2.attention) ||
			_.isEmpty(userInfo2.mailingAddress.state) ||
			_.isEmpty(userInfo2.mailingAddress.city) ||
			_.isEmpty(userInfo2.mailingAddress.postalCode) ||
			_.isEmpty(userInfo2.mailingAddress.addressLine1) ||
			_.isEmpty(userInfo2.email)) {
            updatePageError('fieldInvalid');
            setLoadingState(false);
            processingOrder(false);
            return false;
        }

        updatePageError(undefined);
        processingOrder(true);
        return true;
    };

    const placeOrder = () => {
        setLoadingState(true);

        if (validate()) {
            UserService.placeOrderForPolicyHolderRepublicForms_RI(userInfo2, selectedItems, authHeader).then(
                (response = {}) => {
                    if (!_.isUndefined(response)) {
                        orderPlaced();
                    }
                }
            ).catch((err) => {
                updatePageError('errorPlaceOrder');
                processingOrder(false);
            }).finally(() => {
                setLoadingState(false);
            });
        }
    };

    const overrideProps = {
        '@field': {
            onValueChange: writeValue
        },
        errorMsg: {
            visible: !_.isUndefined(pageError),
            content: translator(messages[pageError])
        },
        dropdownselect: {
            availableValues: stateValues,
            value: selectedState
        },
        formsOrderTableGrid: {
            data: selectedItems
        },
        placeOrderLoader: {
            loading: isLoading
        },
        loaderContainer: {
            visible: isLoading
        },
        userInfoGridContainer: {
            visible: !isLoading
        },
        orderActionLine: {
            visible: !isLoading
        },
        orderContainer: {
            visible: !isLoading
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveValue: readValue,
        resolveCallbackMap: {
            clickNext,
            clickPrevious,
            cancelOrder,
            placeOrder,
            changeState,
            orderPlaced,
            validate
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            resolveValue={resolvers.resolveValue}
        />
    );
}

RIFormsOrderComponent.propTypes = {
    value: PropTypes.shape({})
};

RIFormsOrderComponent.defaultProps = {
    value: {}
};

export default RIFormsOrderComponent;
